// removed by extract-text-webpack-plugin
module.exports = {"container":"qeQkUnrzWl-DpUsSa8-p7","formContainer":"_25FC_HVFHF1LqP8piMJ0E-","usersContainer":"_1QOks6LOonRje-QIVHxtlr","usersColumn":"sjLNZFEkDiV8ZmMYiH9hw","user":"_1afwwjB3qt5fPZ1EyUi3gX","editIcon":"_3r7SbupYS4BfMTmSoBQwGs","modalForm":"_2QzNxA_lrbqGXxONYuxo18","removeModalButton":"_2KI33ETEE3WWfQGe72QlX-"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Users/Users.css
// module id = 56
// module chunks = 0